import { reactive } from 'vue'
import actions from '@/store/student/actions'
import state from '@/store/student/state'
import getters from '@/store/student/getters'

export const studentModule = {
    state: reactive(state),
    actions,
    getters,
}
